/**
 * @description: 获取url参数对象
 * @return {Object}
 */
export function getParamsObj() {
  if (window.location.href.indexOf("?") == -1) return {};
  let arr = window.location.href.split("?")[1].split("&"); //先通过？分解得到？后面的所需字符串，再将其通过&分解开存放在数组里
  let obj = {};
  for (let i of arr) {
    obj[i.split("=")[0]] = i.split("=")[1]; //对数组每项用=分解开，=前为对象属性名，=后为属性值
  }
  return obj;
}
export function objKeySort(obj) {
  var newkey = Object.keys(obj).sort();
  var newObj = {};
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]];
  }
  return newObj;
}

export function procRequestParams(obj) {
  var keys = Object.keys(obj).sort();
  var bodyArr = [];
  for (var k in keys) {
    if (typeof obj[keys[k]] !== "undefined") {
      var value = decodeURIComponent(obj[keys[k]].toString());
      bodyArr.push(keys[k] + "=" + value);
    } else {
      bodyArr.push(keys[k] + "=");
    }
  }
  return bodyArr.join("&");
}

const userAgent = navigator.userAgent.toLowerCase();
const isMobile = /mobile/i.test(userAgent);
const isIOS = /iphone|ipad|ipod/i.test(userAgent);
const systemVersion =
  isMobile &&
  parseInt(
    navigator.userAgent
      .toLowerCase()
      .match(/(os|android).\d/g)[0]
      .slice(-1)
  );
const isLowIOS = isIOS ? systemVersion > 4 && systemVersion < 9 : false;

export { isLowIOS };

let browserReg = {
  Chrome: /Chrome/,
  IE: /MSIE/,
  Firefox: /Firefox/,
  Opera: /Presto/,
  Safari: /Version\/([\d.]+).*Safari/,
  '360': /360SE/,
  QQBrowswe: /QQ/,
}

let deviceReg = {
  iPhone: /iPhone/,
  iPad: /iPad/,
  Android: /Android/,
  Windows: /Windows/,
  Mac: /Macintosh/,
}

export function getUserOsInfo() {
  let userAgentStr = navigator.userAgent
  const userAgentObj = {
    browserName: '',    // 浏览器名称
    browserVersion: '', // 浏览器版本
    osName: '',         // 操作系统名称
    osVersion: '',      // 操作系统版本
    deviceName: '',     // 设备名称
  }
  for (let key in browserReg) {
    if (browserReg[key].test(userAgentStr)) {
      userAgentObj.browserName = key
      if (key === 'Chrome') {
        userAgentObj.browserVersion = userAgentStr.split('Chrome/')[1].split(' ')[0]
      } else if (key === 'IE') {
        userAgentObj.browserVersion = userAgentStr.split('MSIE ')[1].split(' ')[1]
      } else if (key === 'Firefox') {
        userAgentObj.browserVersion = userAgentStr.split('Firefox/')[1]
      } else if (key === 'Opera') {
        userAgentObj.browserVersion = userAgentStr.split('Version/')[1]
      } else if (key === 'Safari') {
        userAgentObj.browserVersion = userAgentStr.split('Version/')[1].split(' ')[0]
      } else if (key === '360') {
        userAgentObj.browserVersion = ''
      } else if (key === 'QQBrowswe') {
        userAgentObj.browserVersion = userAgentStr.split('Version/')[1].split(' ')[0]
      }
    }
  }

  for (let key in deviceReg) {
    if (deviceReg[key].test(userAgentStr)) {
      userAgentObj.osName = key
      if (key === 'Windows') {
        userAgentObj.osVersion = userAgentStr.split('Windows NT ')[1].split(';')[0]
      } else if (key === 'Mac') {
        userAgentObj.osVersion = userAgentStr.split('Mac OS X ')[1].split(')')[0]
      } else if (key === 'iPhone') {
        userAgentObj.osVersion = userAgentStr.split('iPhone OS ')[1].split(' ')[0]
      } else if (key === 'iPad') {
        userAgentObj.osVersion = userAgentStr.split('iPad; CPU OS ')[1].split(' ')[0]
      } else if (key === 'Android') {
        userAgentObj.osVersion = userAgentStr.split('Android ')[1].split(';')[0]
        userAgentObj.deviceName = userAgentStr.split('(Linux; Android ')[1].split('; ')[1].split(' Build')[0]
      }
    }
  }

  return userAgentObj

}
// 获取浏览器类型及版本
export function getBrowserInfo() {
  var Sys = {};
  var ua = navigator.userAgent.toLowerCase();
  var re = ua.trim().split(" ");
  var browserInfo = re[re.length - 1];
  Sys.browser = browserInfo.split("/")[0]
  Sys.ver = browserInfo.split("/")[1]
  return Sys;
}


/** 系统信息 */
export function getSystemInfo() {
  return {
    user_agent: navigator.userAgent,//浏览器UA信息
    system: getUserOsInfo().osName,
    system_version: getUserOsInfo().osVersion,
    browser: getBrowserInfo().browser,
    browser_version: getBrowserInfo().ver
  }
}
/**
 * @description: 获取当前设备
 * @return {Number} 1/2/3 =>安卓/ios/其他
 */
export function getDeviceInfo() {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/android/i.test(userAgent)) {
    return 1;
  } else if (/iphone|ipad|ipod/i.test(userAgent)) {
    return 2;
  } else {
    return 3;
  }
}
// 生成随机数
export const getRandomArbitrary = (min = 0, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min //含最大值，含最小值 
}
